import { createSlice } from '@reduxjs/toolkit';
import { revertAll } from '../actions';

export interface IAppState {
    activeHTTPRequests: number;
    isDarkTheme: boolean;
    session: { [key: string]: any };
    isShowNoInternetPopup: boolean;
}

const initialState: IAppState = {
    activeHTTPRequests: 0,
    isDarkTheme: false,
    session: {},
    isShowNoInternetPopup: false,
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        showLoader: state => {
            return {
                ...state,
                activeHTTPRequests: state.activeHTTPRequests + 1,
            };
        },
        hideLoader: state => {
            return {
                ...state,
                activeHTTPRequests: state.activeHTTPRequests > 1 ? state.activeHTTPRequests - 1 : 0,
            };
        },
        toggleIsDarkTheme: state => {
            return {
                ...state,
                isDarkTheme: !state.isDarkTheme,
            };
        },
        setSession: (state, action) => {
            return {
                ...state,
                session: action.payload,
            };
        },
        forceHideLoader: state => {
            return {
                ...state,
                activeHTTPRequests: 0,
            };
        },
        showNoInternetPopUp: state => {
            return {
                ...state,
                isShowNoInternetPopup: true,
            };
        },
        hideNoInternetPopUp: state => {
            return {
                ...state,
                isShowNoInternetPopup: false,
            };
        },
    },
    extraReducers: builder => {
        builder.addCase(revertAll, () => initialState);
    },
});

export const {
    showLoader,
    hideLoader,
    toggleIsDarkTheme,
    setSession,
    forceHideLoader,
    showNoInternetPopUp,
    hideNoInternetPopUp,
} = appSlice.actions;
export const appReducer = appSlice.reducer;
